<script>
import axios from 'axios';


export default {

    data() {
        return {
            loadingDetail: true,
            dashboardCount: [],
        }
    },
    methods: {
        getDashboard() {
            axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
            axios.get(process.env.VUE_APP_AR_API_BASEURL + "repayments/dashboard")
            .then((response) => {
                if (response && response.data) {
                    this.loadingDetail = false;
                    this.dashboardCount = response.data;
                } else {
                    this.loadingDetail = false;
                }
            })
                .catch((error) => {
                    this.loadingDetail = false;
                    console.error('API Error:', error); // Debug log
            });
        },
    },

    mounted() {
        this.getDashboard();
    },
}
</script>

<template>
    <div class="mb-4" v-if="loadingDetail">
        <div class="spinner-border text-success" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="mb-4" v-else>
        <div class="mb-4">
            <h5 class="mb-1">Transaction In Progress</h5>
        </div>
        <div class="row g-3">
            <div class="col-lg-2" v-for="item in dashboardCount" :key="item.id || item.date">
                <router-link :to="'/finance/recollect-automation/'+item.dateUnformatted" class="text-decoration-none">
                    <div class="card">
                        <div class="card-body d-flex gap-3 align-items-center">
                            <div class="flex-grow-1">
                                <h5 class="fs-15">{{ item.total }}</h5>
                                <p class="mb-0 text-muted">{{ item.date }}</p>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>

        </div>
    </div>
</template>

